import { render, staticRenderFns } from "./WillBeneficiariesFinancialVulnerableYN.vue?vue&type=template&id=2889d2dd"
import script from "./WillBeneficiariesFinancialVulnerableYN.vue?vue&type=script&lang=js"
export * from "./WillBeneficiariesFinancialVulnerableYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports